import { Flex, FlexItem, ProgressCircle, Table as BigDesignTable } from '@bigcommerce/big-design';

export default function CustomTable({ isLoading, ...rest }) {
	if (isLoading) {
		return (
			<div style={{ textAlign: 'center' }}>
				<ProgressCircle size="large" />
			</div>
		);
	}

	return (
		<Flex>
			<FlexItem style={{ width: '100%', overflowX: 'scroll' }}>
				<BigDesignTable {...rest} />
			</FlexItem>
		</Flex>
	);
}